function PrimaryGradientButton({ text, noShadow, handleClick }) {
  return (
    <button
      className="btn-primary-gradient"
      style={{ boxShadow: noShadow ? "none" : "" }}
      onClick={handleClick}
    >
      {text}
    </button>
  );
}

export default PrimaryGradientButton;
